import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import {
  changeJob,
  createJob,
  fetchSingleJob,
} from '../features/jobs/jobSlice';
import handleInput from '../utils/handleInput';

const JobForm = () => {
  const initialFormData = {
    title: '',
    type: '',
    salary: '',
    deadline: '',
  };

  const [formData, setFormData] = useState(initialFormData);
  const { jobId } = useParams();

  const { singleJob } = useSelector((state) => state.jobs);

  const dispatch = useDispatch();

  useEffect(() => {
    if (JSON.stringify(singleJob) === JSON.stringify({})) {
      dispatch(fetchSingleJob(jobId));
    } else {
      setFormData(singleJob);
    }
  }, [singleJob, jobId, dispatch]);

  const { title, type, salary, deadline } = formData;

  const navigate = useNavigate();

  const handleChange = (e) => {
    const inputValue = handleInput(e);

    setFormData((prevFormData) => {
      return {
        ...prevFormData,
        [e.target.name]: inputValue,
      };
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (jobId) {
      dispatch(changeJob({ id: jobId, data: formData }));
      navigate('/');
    } else {
      dispatch(createJob(formData));
    }
    setFormData(initialFormData);
  };

  return (
    <main className="max-w-3xl rounded-lg mx-auto relative z-20 p-10 xl:max-w-none bg-[#1E293B]">
      <h1 className="mb-10 text-center lws-section-title">
        {jobId ? 'Edit Job' : 'Add New Job'}
      </h1>

      <div className="max-w-3xl mx-auto">
        <form className="space-y-6" onSubmit={handleSubmit}>
          <div className="fieldContainer">
            <label
              htmlFor="lws-JobTitle"
              className="text-sm font-medium text-slate-300"
            >
              Job Title
            </label>
            <select
              id="lws-JobTitle"
              name="title"
              required
              value={title}
              onChange={handleChange}
            >
              <option value="" hidden>
                Select Job
              </option>
              <option value="Software Engineer">Software Engineer</option>
              <option value="Software Developer">Software Developer</option>
              <option value="Full Stack Developer">Full Stack Developer</option>
              <option value="MERN Stack Developer">MERN Stack Developer</option>
              <option value="DevOps Engineer">DevOps Engineer</option>
              <option value="QA Engineer">QA Engineer</option>
              <option value="Product Manager">Product Manager</option>
              <option value="Social Media Manager">Social Media Manager</option>
              <option value="Senior Executive">Senior Executive</option>
              <option value="Junior Executive">Junior Executive</option>
              <option value="Android App Developer">
                Android App Developer
              </option>
              <option value="IOS App Developer">IOS App Developer</option>
              <option value="Frontend Developer">Frontend Developer</option>
              <option value="Frontend Engineer">Frontend Engineer</option>
            </select>
          </div>

          <div className="fieldContainer">
            <label htmlFor="lws-JobType">Job Type</label>
            <select
              id="lws-JobType"
              name="type"
              required
              value={type}
              onChange={handleChange}
            >
              <option value="" hidden>
                Select Job Type
              </option>
              <option value="Full Time">Full Time</option>
              <option value="Internship">Internship</option>
              <option value="Remote">Remote</option>
            </select>
          </div>

          <div className="fieldContainer">
            <label htmlFor="lws-JobSalary">Salary</label>
            <div className="flex border rounded-md shadow-sm border-slate-600">
              <span className="input-tag">BDT</span>
              <input
                type="number"
                name="salary"
                id="lws-JobSalary"
                required
                className="!rounded-l-none !border-0"
                placeholder="20,00,000"
                value={salary}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="fieldContainer">
            <label htmlFor="lws-JobDeadline">Deadline</label>
            <input
              type="date"
              name="deadline"
              id="lws-JobDeadline"
              required
              value={deadline}
              onChange={handleChange}
            />
          </div>

          <div className="text-right">
            <button
              type="submit"
              id="lws-submit"
              className="cursor-pointer btn btn-primary w-fit"
            >
              {jobId ? 'Edit' : 'Submit'}
            </button>
          </div>
        </form>
      </div>
    </main>
  );
};

export default JobForm;
